import { render, staticRenderFns } from "./DesignObjectionToUsList.vue?vue&type=template&id=9ffc4c3a&"
import script from "./DesignObjectionToUsList.vue?vue&type=script&lang=js&"
export * from "./DesignObjectionToUsList.vue?vue&type=script&lang=js&"
import style0 from "./DesignObjectionToUsList.vue?vue&type=style&index=0&id=9ffc4c3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports